module.exports = __webpack_public_path__ + "media/homepage/william_@2x-c4285318.png";